export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/dancehall.aa8e3d5.svg";